export const UPLOAD_FILES_START = 'UPLOAD_FILE_START';
export const UPLOAD_FILES_SUCCESS = 'UPLOAD_FILES_SUCCESS';
export const UPLOAD_FILES_FAILURE = 'UPLOAD_FILES_FAILURE';
export const UPLOAD_FILES_CLEAR_STORE = 'UPLOAD_FILES_CLEAR_STORE';
